// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  HOME_SET_UPLOAD_MODE,
} from './constants';

export function setUploadMode(isUpload) {
  return {
    type: HOME_SET_UPLOAD_MODE,
    data: {isUpload}
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_SET_UPLOAD_MODE:
      return {
        ...state,
        uploadMode: action.data.isUpload
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/setUploadMode.js